// extracted by mini-css-extract-plugin
export default {"monitoredPatientsChart":"monitored-patients-chart_monitoredPatientsChart__jLmI8","chartWrapper":"monitored-patients-chart_chartWrapper__nd4M5"};